import { OrderItem } from '@order/orderTypes'
import { getStockState, OrderState } from './state/orderState'
import { useOrderState } from './useOrderState'
import { useMemo } from 'react'
import { RegionConfig } from '@ca/common/types'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'
import { StockSettings } from '@ca/common'
import { StockSettingsKey } from '@frame/StockUtils'

export const stockItemsValid = (
  items: OrderItem[],
  stock: OrderState['stock'],
  config: RegionConfig | undefined
) => {
  return items.every((item) => {
    const frameState = getStockState(item, stock, config, 'frame')

    const templeState = item.temple
      ? getStockState(item, stock, config, 'temple')
      : 'positive'

    return frameState === 'positive' && templeState === 'positive'
  })
}

const useStockValid = (
  localStock?: Record<StockSettingsKey, StockSettings>
) => {
  const config = useRemoteConfig()
  const items = useOrderState((s) => s.order.items)
  const stock = useOrderState((s) => s.order.stock)
  const isValid = useMemo(
    () => stockItemsValid(items, localStock || stock, config?.region),
    [items, stock, localStock, config]
  )
  return isValid
}

export default useStockValid
